export const pages = [
    "login_with_explisoft",
    /** DO NOT DELETE THIS LINE, IMPORT PUBLIC PAGE HERE **/
]